import '../styles/styles.scss';
import { stringify } from 'postcss';
// import { makeArray } from 'jquery';
import { showroom_init, openCity, showroomEnableForm, scrollToElement, openFormPopup, clodePoppup, openFormPopupKeyPressed, closePoppupKeyPressed, changeUrl, getUrlParams, mobileOpenMap, mobileCloseMap, mobileOpenNavigation, mobileCloseNavigation } from './showroom.js';
import { videoBtns } from './frontpage.js';
import { innerMenu, createMenu, addActiveDesktop, removeActiveDesktop } from './menu-header.js';
import { sliders } from './sliders';
import { halves,incrementNumericValue } from './models.js';
import { fieldOnFocusBlur } from './forms';
import { downloadPdf } from './download-pdf.js';
import { jobs } from './jobs.js';
import { clickableCard, sortCards } from './cards';
import { selectModel } from './services';

jQuery(document).ready(function () {
    console.log('hello dist files');
    sliders();
    halves();
    fieldOnFocusBlur();
    jobs();
    clickableCard();
    sortCards();
    incrementNumericValue();
    selectModel();
    $('.site-content').css('padding-top', $('header.header').height());
    $(document).keyup(function (event) {
        if (event.which === 27) {
            jQuery(".menu").removeClass("menu-open");
            jQuery(".menu-wrapper .bar").removeClass("animate");
            jQuery("body").removeClass("fixed");
            cef.clodePoppup();
        } // 27 is the keycode for the Escape key
    });
    videoBtns();

    createMenu();
    jQuery('.menu-item-has-children > a, .footer_title').on('click', function (event) {
        event.preventDefault();
    });
});
// scope global
class cef { };

cef.openCity = openCity;
cef.showroomArea = showroom_init;
cef.changeUrl = changeUrl;
cef.getUrlParams = getUrlParams;
cef.showroom_enable_form = showroomEnableForm;
cef.scrollToElement = scrollToElement;
cef.showroom_enable_form = showroomEnableForm;
cef.openFormPopup = openFormPopup;
cef.openFormPopupKeyPressed = openFormPopupKeyPressed;
cef.clodePoppup = clodePoppup;
cef.closePoppupKeyPressed = closePoppupKeyPressed;
cef.innerMenu = innerMenu;
cef.downloadPdf = downloadPdf;
cef.addActiveDesktop = addActiveDesktop;
cef.removeActiveDesktop = removeActiveDesktop;
cef.mobileOpenMap = mobileOpenMap;
cef.mobileCloseMap = mobileCloseMap;
cef.mobileOpenNavigation = mobileOpenNavigation;
cef.mobileCloseNavigation = mobileCloseNavigation;
module.exports = cef;